/* ------------------------------------------------------------------
   Product-card variant swatches -> keep Add to cart in sync.
   FIXED — sold-out products showed an active "Add to cart" on
   collection pages. `unavailable` was derived ONLY from the checked
   colour swatch, so swatch-less products (single variant) came out
   as available and this overwrote the correct server-rendered
   `value="Sold out" disabled` markup.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  function syncCard(card) {
    if (!card) return;

    var form = card.querySelector('form.bs');
    if (!form) return;

    var submit = form.querySelector('input[type="submit"]');
    if (!submit) return;

    // Remember the server-rendered (Liquid) availability, once per button,
    // before anything here modifies it.
    if (submit.dataset.initialUnavailable === undefined) {
      submit.dataset.initialUnavailable = String(
        submit.disabled || submit.classList.contains('soldout_class')
      );
    }

    var checked = card.querySelector('input.ColorSwatch__Radio:checked');
    var unavailable;

    if (checked) {
      // Card has colour swatches: the selected swatch is the source of truth.
      unavailable = checked.dataset.unavailable === 'true';

      if (checked.dataset.variantId) {
        var hidden = form.querySelector('.variantId');
        if (hidden) hidden.value = checked.dataset.variantId;
      }
    } else {
      // No swatches on this card: trust what the server rendered.
      unavailable = submit.dataset.initialUnavailable === 'true';
    }

    submit.disabled = unavailable;
    submit.value = unavailable
      ? (submit.dataset.soldOutText || 'Sold out')
      : (submit.dataset.addText || 'Add to cart');
    submit.classList.toggle('soldout_class', unavailable);
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('ColorSwatch__Radio')) {
      syncCard(e.target.closest('product-card'));
    }
  });

  // Last line of defence: never submit a sold-out card, even if some other
  // script re-enables the button. Capture phase, so it runs first.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('bs')) return;

    var submit = form.querySelector('input[type="submit"]');
    if (submit && (submit.disabled || submit.classList.contains('soldout_class'))) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  function initAll() {
    document.querySelectorAll('product-card').forEach(syncCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Cards get re-rendered by filtering, sorting and pagination.
  new MutationObserver(function (records) {
    for (var r = 0; r < records.length; r++) {
      for (var n = 0; n < records[r].addedNodes.length; n++) {
        var node = records[r].addedNodes[n];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('product-card')) syncCard(node);
        if (node.querySelectorAll) node.querySelectorAll('product-card').forEach(syncCard);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();